import { useEnquiryContext } from 'pages/Enquiry/context';
import { useMemo } from 'react';

export interface EnquiryHeaderHook {
  hasLogo: boolean;
  isLoading: boolean;
  logoContent: string | undefined;
}

export default function useEnquiryHeader(): EnquiryHeaderHook {
  const { logo, hasLogo } = useEnquiryContext();

  const logoContent = useMemo(() => {
    if (!logo) return undefined;
    const { content, mimetype } = logo;
    if (!content) return undefined;
    return `data:${mimetype || 'image/png'};base64,${content}`;
  }, [logo]);

  return {
    logoContent,
    isLoading: !logoContent,
    hasLogo,
  };
}
